/** Krótki komunikat po przejściu na inny ekran (np. „Jesteś teraz w domu…”) — przekazywany w location.state. */
export function flashFrom(state: unknown): string | null {
  return state && typeof state === 'object' && 'flash' in state && typeof state.flash === 'string' ? state.flash : null;
}
